export enum showType{
    menu = 1,  //显示全部
    page = 2
}

export type openType = 1 | 2

export enum pathType {
    mine = 1,
    iframe = 2,
    tag = 3
}

export interface IMetaType {
    icon?: string
    title?: string
    level?: number

    showType?:showType
    pathType?:pathType
    sort?:number
    openType?:openType
    id?: string
    isMenu?: boolean
}
export enum RouteLevel {
    parent = 1,
    child = 2,
    child1 = 3
}